import { createContext, useContext } from "react";

import type { PdfViewerContextValue } from "./PdfViewer.types";

export const PdfViewerContext = createContext<PdfViewerContextValue | null>(
  null,
);

export function usePdfViewerContext(): PdfViewerContextValue {
  const context = useContext(PdfViewerContext);

  if (context === null) {
    throw new Error("usePdfViewerContext must be used within a PdfViewer.");
  }

  return context;
}
